/**
 * contains the abi and contract address
*/

class GuildSettingsContract {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildContractAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "guildId",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "UserChoseDefaultGuild",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "guildId",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "UserLeftGuild",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32[6]",
				"name": "guildPublicKey",
				"type": "bytes32[6]"
			},
			{
				"internalType": "string",
				"name": "guildName",
				"type": "string"
			},
			{
				"internalType": "bytes32",
				"name": "encryptedKeyIpfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "contentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "userPublicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "createGuildWithPeople",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "guildId",
				"type": "uint256"
			}
		],
		"name": "leaveGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "guildId",
				"type": "uint256"
			}
		],
		"name": "userChoseDefaultGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        this.contractAddress = '0x1775E7d49D41b01c2D5811ED51ee2d22c9706f86';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildSettingsContract;
